import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

import CoverImageStack from "../../../ui/components/CoverImage/CoverImageStack";
import DropdownMenu from "../../../ui/components/DropdownMenu/DropdownMenu";
import Label from "../../../ui/components/Label/Label";
import PageView from "../../../ui/views/PageView/PageView";

import useWorkDropdownMenuOptions from "./hooks/useWorkDropdownMenuOptions";

export default function WorkView({ work, children }) {
	const { t } = useTranslation();

	const dropdownMenuOptions = useWorkDropdownMenuOptions({ work });

	return (
		<>
			<PageView
				image={<CoverImageStack data={work} size={70} />}
				header={work.name}
				subheader={work.imprint?.name || work.publisher?.name}
				extra={
					<>
						<Label>{t("work", "Work")}</Label>
						<DropdownMenu options={dropdownMenuOptions} />
					</>
				}
			>
				{children}
			</PageView>
		</>
	);
}
